// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__33r6j","error":"Textarea_error__F1P6X","readonly":"Textarea_readonly__2Qawq","disabled":"Textarea_disabled__1ifJ0"};